import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@/forms/_fields_v2/Divider';
import useNetwork from '@/hooks/useNetwork';
import Section from '@/pages/profile-edit/Section';
import Activity from './Activity';
import Budget from './Budget';
import Commitment from './Commitment';
import Date from './Date';
import Days from './Days';
import Documents from './Documents';
import Grant from './Grant';
import Location from './Location';
import Participants from './Participants';
import ProjectDemonstration from './ProjectDemonstration';
import ProjectGoals from './ProjectGoals';
import ProjectSummary from './ProjectSummary';
import ProjectTitle from './ProjectTitle';
import Resources from './Resources';
import School from './School';
import Skills from './Skills';
import StudentAges from './StudentAges';
import StudentCount from './StudentCount';
import StudentSize from './StudentSize';
import Subjects from './Subjects';
import Time from './Time';

export default function Layout(props) {
  const { project } = props;

  const network = useNetwork();

  const isEligibleForGrants = network?.data?.grants === 'Yes';

  return (
    <div className="space-y-8">
      <Section
        title="School"
        subtitle={(
          <>
            Where are your learners located?
          </>
        )}
      >
        <div className="grid grid-cols-1 gap-6">
          <School project={project} />
        </div>
      </Section>
      <Divider />
      <Section
        title="Vision"
        subtitle={(
          <>
            What do you want to happen and what needs do you have?
          </>
        )}
      >
        <div className="grid grid-cols-1 gap-6">
          <Activity project={project} />
          <ProjectTitle project={project} />
          <ProjectGoals project={project} />
          <ProjectDemonstration project={project} />
          <ProjectSummary project={project} />
          <Resources project={project} />
        </div>
      </Section>
      <Divider />
      <Section
        title="Audience"
        subtitle={(
          <>
            Who will partners work with?
          </>
        )}
      >
        <div className="grid grid-cols-1 gap-6">
          <Participants project={project} />
          <StudentCount project={project} />
          <StudentAges project={project} />
          <StudentSize project={project} />
        </div>
      </Section>
      <Divider />
      <Section
        title="Partner"
        subtitle={(
          <>
            What subject matter experience will your partner need?
          </>
        )}
      >
        <div className="grid grid-cols-1 gap-6">
          <Subjects project={project} />
          <Skills project={project} />
        </div>
      </Section>
      <Divider />
      <Section
        title="Timing & Logistics"
        subtitle={(
          <>
            When do you need a partner? How will you meet?
          </>
        )}
      >
        <div className="grid grid-cols-1 gap-6">
          <Date project={project} />
          <Days project={project} />
          <Commitment project={project} />
          <Time project={project} />
          <Location project={project} />
        </div>
      </Section>
      <Divider />
      <Section
        title="Documents"
        subtitle={(
          <>
            Do you have any supporting documents to help partners understand your idea?
          </>
        )}
      >
        <div className="grid grid-cols-1 gap-6">
          <Documents project={project} />
        </div>
      </Section>
      {isEligibleForGrants && (
        <>
          <Divider />
          <Section
            title="Support needed"
            subtitle={(
              <>
                Do you need funding for this project?
              </>
            )}
          >
            <div className="grid grid-cols-1 gap-6">
              <Grant project={project} />
              {project.data.grant === 'Yes' && (
                <Budget project={project} />
              )}
            </div>
          </Section>
        </>
      )}
    </div>
  );
}

Layout.propTypes = {
  project: PropTypes.shape({
    data: PropTypes.shape({
      grant: PropTypes.string,
    }),
  }).isRequired,
};
